import $ from 'jquery';
import BaseEvent from './base-event';

export default class ContentEvents extends BaseEvent {
  constructor() {
    super({
      event_id: '23',
      category: 'content',
      action: 'click',
    });

    this.init();
  }

  init() {
    this.cardsEvents();
    this.playersEvents();
    this.collectionsEvents();
  }

  cardsEvents() {
    $(`a.super-banner__container,
      a.news-card__container,
      a.news-list__item-link,
      a.citytv-videos-list__item-link,
      a.collections-video-list__item-link`).on('click', (e) => {
      const widgetName = $(e.currentTarget).parents(`[${this.widgetNameSelector}]`).attr(this.widgetNameSelector);
      this.fireEvent({
        label: this.toNormalizedString($(e.currentTarget).find('[class*=__heading]').text()),
        destination_url: e.currentTarget.href,
        widget_name: widgetName ? this.toNormalizedString(widgetName) : null,
      });
    });
  }

  playersEvents() {
    $('a.squad-list__item-link').on('click', (e) => {
      const widgetName = $(e.currentTarget).parents(`[${this.widgetNameSelector}]`).attr(this.widgetNameSelector);
      const label = $(e.currentTarget).find('.member-card__full-name .member-card__name').toArray()
        .map((elem) => elem.innerText)
        .join('_');
      this.fireEvent({
        label: this.toNormalizedString(label),
        destination_url: e.currentTarget.href,
        widget_name: widgetName ? this.toNormalizedString(widgetName) : null,
      });
    });
  }

  collectionsEvents() {
    $('a.collections-list__item-link').on('click', (e) => {
      const widgetName = $(e.currentTarget).parents(`[${this.widgetNameSelector}]`).attr(this.widgetNameSelector);
      this.fireEvent({
        label: this.toNormalizedString($(e.currentTarget).find('.collections-card__title').text()),
        destination_url: e.currentTarget.href,
        widget_name: widgetName ? this.toNormalizedString(widgetName) : null,
      });
    });
  }
}
